export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <a href="#hero" className="inline-block text-2xl mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              漫蛙漫画网
            </a>
            <p className="text-sm text-white/60 leading-relaxed">
              专注漫画追更与漫画最新更新的专业平台。追漫画更新速度快，连载漫画追更免费看，追更提醒不错过任何一话。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <div className="space-y-2.5">
              <a href="#topics" className="block text-sm text-white/60 hover:text-primary-400 transition-colors">热议话题</a>
              <a href="#ranking" className="block text-sm text-white/60 hover:text-primary-400 transition-colors">人气热榜</a>
              <a href="#updates" className="block text-sm text-white/60 hover:text-primary-400 transition-colors">最新快讯</a>
              <a href="#cards" className="block text-sm text-white/60 hover:text-primary-400 transition-colors">热门连载</a>
              <a href="#faq" className="block text-sm text-white/60 hover:text-primary-400 transition-colors">追更问答</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">追更服务</h4>
            <div className="space-y-2.5">
              <a href="#app" className="block text-sm text-white/60 hover:text-primary-400 transition-colors">追更助手</a>
              <a href="#comments" className="block text-sm text-white/60 hover:text-primary-400 transition-colors">漫友热议</a>
              <a href="#media" className="block text-sm text-white/60 hover:text-primary-400 transition-colors">精选漫评</a>
              <a href="#index" className="block text-sm text-white/60 hover:text-primary-400 transition-colors">追更专题</a>
              <a href="#contact" className="block text-sm text-white/60 hover:text-primary-400 transition-colors">投稿联系</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-white/40 leading-relaxed">
              漫蛙漫画网持续拓展漫画追更生态合作，欢迎优质漫画平台与创作者加入。
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/40">
            &copy; {new Date().getFullYear()} 漫蛙漫画网 - 漫画追更与漫画最新更新平台。保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-sm text-white/40 hover:text-primary-400 transition-colors">首页</a>
            <a href="#about" className="text-sm text-white/40 hover:text-primary-400 transition-colors">关于漫蛙</a>
            <a href="#faq" className="text-sm text-white/40 hover:text-primary-400 transition-colors">追更问答</a>
          </div>
        </div>
      </div>
    </footer>
  );
}